import React, { useState, useEffect } from 'react';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import { useSelector } from 'react-redux';
import {
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { Tooltip } from 'antd';
import { toast } from 'react-toastify';
import methodModel from '../../../methods/methods';
import Layout from '../../../components/global/layout';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Button, Modal } from 'antd';

const AddEditTemplate = () => {
  const [images, setImages] = useState({ image: '', banner: '', icon: '' });
  const [open, setOpen] = useState(false);

  const { id, type } = useParams();
  const [location] = useSearchParams();

  const query = location.get('certificate');

  const [form, setform] = useState({title : ""});
  const [tab, setTab] = useState('info');
  const history = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const user = useSelector((state) => state.user);
  const formValidation = [
    { key: 'title', required: true },
    { key: 'content', required: true },
  ];

  const onOKK = () => {
    history('/certification/add');
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    let invalid = methodModel.getFormError(formValidation, form);
    if (tab == 'seo' && invalid) {
      toast.error('Please fill Required Fields');
    }

    if (invalid) return;
    let method = 'post';
    let url = 'certificateTemplate';
    let value = {
      title: form?.title,
      content: form?.content,
    };
    if (id) {
      method = 'put';
      url = 'certificateTemplate';
      value.id = id;
    } else {
      value.addedBy = user._id;
      delete value.id;
    }

    loader(true);
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        if (query) {
          loader(false);
          setform({ title: '', content: '' });
          const success = () => {
            Modal.success({
              content: 'Your template has created, you can use your template',
              afterClose: onOKK(),
            });
          };
          return success();
        }
        history('/certificate-templates');
      }
      loader(false);
    });
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    if (id) {
      loader(true);
      ApiClient.get('certificateTemplate', { id }).then((res) => {
        if (res.success) {
          let value = res.data;
          setform({
            ...form,
            title: res?.data?.title,
            content: res?.data?.content,
            id: res?.data?.id,
          });
        }
        loader(false);
      });
    }
  }, [id]);

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit}>
          <div className="pprofile1 shadow-lg">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <button
                  type="button"
                  onClick={(e) => back()}
                  className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all   discard mr-3"
                >
                  <i className="fa fa-angle-left text-lg"></i>
                </button>
              </Tooltip>
              <div>
                <h3 className="text-2xl font-semibold text-[#111827]">
                  {id ? ' Edit ' : ' Add '}
                  Cerificate Template
                </h3>
                <p class="text-sm font-normal text-[#525252]">
                  Here you can see all about your Cerificate Template
                </p>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4">
              {tab == 'info' ? (
                <>
                  <div className="col-span-12 md:col-span-6">
                    <label>
                      Title<span className="star">*</span>
                    </label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form?.title}
                      onChange={(e) =>
                        setform({ ...form, title: e.target.value })
                      }
                    // required
                    />
                    {submitted && !form?.title ? (
                      <div className="text-danger">Title is Required</div>
                    ) : null}
                  </div>
                  <div className="col-span-12 md:col-span-12">
                    <label>
                      Content<span className="star">*</span>
                    </label>
                    <ReactQuill
                      theme="snow"
                      value={form?.content}
                      onChange={(e) => {
                        setform(prev=>({ ...prev, content: e }));
                      }}
                    />
                    {submitted && !form.content ? (
                      <div className="text-danger">Content is Required</div>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="col-span-12 md:col-span-12">
                    <label>URL Key</label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.urlKey}
                      onChange={(e) =>
                        setform({ ...form, urlKey: e.target.value })
                      }
                    />
                    <div className="small">Leave empty to auto generate</div>
                  </div>
                  <div className="col-span-12 md:col-span-12">
                    <label>
                      Meta Title<span className="star">*</span>
                    </label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.metaTitle}
                      onChange={(e) =>
                        setform({ ...form, metaTitle: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="col-span-12 md:col-span-12">
                    <label>
                      Meta Description<span className="star">*</span>
                    </label>
                    <textarea
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.metaDescription}
                      onChange={(e) =>
                        setform({ ...form, metaDescription: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="col-span-12 md:col-span-12">
                    <label>
                      Keywords<span className="star">*</span>
                    </label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.keywords}
                      onChange={(e) =>
                        setform({ ...form, keywords: e.target.value })
                      }
                      required
                    />
                  </div>
                </>
              )}
            </div>
            {form?.content?.length > 0 ? (
              <Button
                className="!px-4 text-sm font-normal bg-[#A12238] text-white h-10 flex items-center justify-center gap-2 !bg-primary rounded-lg shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed mt-3"
                type="primary"
                onClick={() => setOpen(true)}
              >
                Preview
              </Button>
            ) : null}
            <Modal
              title="Template Preview"
              centered
              open={open}
              onOk={() => setOpen(false)}
              onCancel={() => setOpen(false)}
              width={1000}
            >
              <div dangerouslySetInnerHTML={{ __html: form?.content }}></div>
            </Modal>
            <div className="flex justify-end mt-4">
              <button
                type="submit"
                className="!px-4 text-sm font-normal bg-[#A12238] text-white h-10 flex items-center justify-center gap-2 !bg-primary rounded-lg shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEditTemplate;
